import { css } from 'styled-components';

export const resetElementsCss = css`
  .reset-btn {
    border: 0;
    padding: 0;
    outline: none;
    cursor: pointer;
  }
`;
